import { toDateTime, cpfCnpjMask } from "Helpers/Format";

export const downloadColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome",
    accessor: "name",
  },
  {
    Header: "CNPJ",
    accessor: (row) => (row.cnpj ? cpfCnpjMask(row.cnpj) : ""),
  },
  {
    Header: "E-mail",
    accessor: "email",
  },
  {
    Header: "Telefone",
    accessor: "phone",
  },
  {
    Header: "Usuários",
    accessor: "users_count",
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "",
  },
  {
    Header: "Data de Criação",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];

export const columns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome",
    accessor: "name",
  },
  {
    Header: "CNPJ",
    accessor: (row) => (row.cnpj ? cpfCnpjMask(row.cnpj) : ""),
  },
  {
    Header: "E-mail",
    accessor: "email",
  },
  {
    Header: "Telefone",
    accessor: "phone",
  },
  {
    Header: "Usuários",
    accessor: "users_count",
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "",
  },
];
